var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_7933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1773 3.38336C14.9337 3.28188 14.6654 3.25521 14.4066 3.30673C14.1478 3.35826 13.9102 3.48565 13.724 3.67269L12 5.39669L8.94267 2.33936C8.69263 2.0894 8.35355 1.94897 8 1.94897C7.64645 1.94897 7.30737 2.0894 7.05733 2.33936L4 5.39669L2.276 3.67269C2.08953 3.48628 1.85198 3.35934 1.59338 3.30791C1.33477 3.25649 1.06673 3.28289 0.823127 3.38379C0.579528 3.48468 0.37131 3.65553 0.224798 3.87475C0.0782854 4.09396 5.62991e-05 4.35169 0 4.61536L0 11.6727C0.00105857 12.5564 0.352588 13.4037 0.97748 14.0285C1.60237 14.6534 2.4496 15.005 3.33333 15.006H12.6667C13.5504 15.005 14.3976 14.6534 15.0225 14.0285C15.6474 13.4037 15.9989 12.5564 16 11.6727V4.61536C16.0001 4.35167 15.9219 4.09388 15.7755 3.87459C15.6291 3.6553 15.4209 3.48435 15.1773 3.38336Z",
    fill: "#F79A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_7933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.339355)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.04d0dfd73272847eeebd290a6c30ebcc.svg";
export { ForwardRef as ReactComponent };